let { Checkbox, Datepicker, Text, Select } = require('../../../../../../packages/account-ui');
let PurposeTree = require('../purpose-tree');
let LegalTree = require('../legal-tree');
let PaymentTree = require('../payment-tree');
let css = require('./filter.css');
let signalsAddParams = require('../../../../../../signals/custom-order/additional-parameters');
let filials = require('../../../../../../signals/custom-order/filials');
let accountUi = require('../../../../../../signals/accountUi');
let utils = require('../../../../../../signals/utils');
let mapClasses = require('../../../../../../signals/custom-order/map-classes');
let numberOfEmployees = require('../../../../../../signals/custom-order/number-of-employees');
let filterableTreeFactory = require('../../../filterable-tree');
let SCHEMES = require('../../../../../../helpers/scheme');

class AdditionalParameters {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let isSmallTree = this.$context.props.isSmallTree === 'true';
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }, { isSmallTree }));
    }
}

module.exports = {
    constructor: AdditionalParameters,
    children: [
        {
            name: 'checkbox-is-must',
            component: Checkbox,
            props: {
                signal: signalsAddParams.setExportColumnIsMustBeFilled
            },
            watcher: (attributes) => ({
                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'isMustBeFilled']
            })
        },
        {
            name: 'datepicker-two',
            component: Datepicker,
            props: {
                scrollType: 'month',
                scrollPage: accountUi.scrollPageDatepicker(['order', 'addParams', 'datepicker2', 'calendar']),
                toggleDropdown: utils.togglePopup('datepicker2'),
                selectDate: signalsAddParams.selectDate('datepicker2', false),
                clearInput: signalsAddParams.clearDatepicker(['order', 'addParams', 'datepicker2', 'value'])
            },
            watcher: {
                mod: ['order', 'addParams', 'computed', 'datepicker2', 'mod'],
                withInputs: ['order', 'addParams', 'computed', 'datepicker2', 'withInputs'],
                withoutButton: ['order', 'addParams', 'computed', 'datepicker2', 'withoutButton'],
                selectedDate: ['order', 'addParams', 'computed', 'datepicker2', 'selectedDate'],
                calendars: ['order', 'addParams', 'computed', 'datepicker2', 'calendars'],
                range: ['order', 'addParams', 'computed', 'datepicker2', 'range'],
                availableRange: ['order', 'addParams', 'computed', 'datepicker2', 'availableRange'],
                title: ['order', 'addParams', 'computed', 'datepicker2', 'title'],
                isOpen: ['order', 'popups', 'datepicker2', 'isOpen'],
                isDisabled: ['order', 'addParams', 'computed', 'datepicker2', 'isDisabled']
            }
        },
        {
            name: 'datepicker',
            component: Datepicker,
            props: {
                scrollType: 'month',
                scrollPage: accountUi.scrollPageDatepicker(['order', 'addParams', 'datepicker', 'calendar']),
                toggleDropdown: utils.togglePopup('datepicker'),
                selectDate: signalsAddParams.selectDate('datepicker', true),
                clearInput: signalsAddParams.clearDatepicker(['order', 'addParams', 'datepicker', 'value'])
            },
            watcher: {
                mod: ['order', 'addParams', 'computed', 'datepicker', 'mod'],
                withInputs: ['order', 'addParams', 'computed', 'datepicker', 'withInputs'],
                withoutButton: ['order', 'addParams', 'computed', 'datepicker', 'withoutButton'],
                selectedDate: ['order', 'addParams', 'computed', 'datepicker', 'selectedDate'],
                calendars: ['order', 'addParams', 'computed', 'datepicker', 'calendars'],
                range: ['order', 'addParams', 'computed', 'datepicker', 'range'],
                availableRange: ['order', 'addParams', 'computed', 'datepicker', 'availableRange'],
                title: ['order', 'addParams', 'computed', 'datepicker', 'title'],
                isOpen: ['order', 'popups', 'datepicker', 'isOpen'],
                isDisabled: ['order', 'addParams', 'computed', 'datepicker', 'isDisabled']
            }
        },
        {
            name: 'purpose-tree',
            component: PurposeTree,
            watcher: {
                isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'Purpose', 'isChecked']
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'legal-tree',
            component: LegalTree,
            watcher: {
                isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'LegalForm', 'isChecked']
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'payment-tree',
            component: PaymentTree,
            watcher: {
                isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'PaymentTypes', 'isChecked']
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'map-classes-tree',
            component: filterableTreeFactory({
                basePath: ['order', 'addParams', 'mapClasses', 'tree']
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id: 'mapClasses',
                onItemCheck: mapClasses.onItemCheck,
                onSetAll: mapClasses.onSetAll,
                minFilterLength: 2,
                showOnlyTree: true,
                isInnerTree: true
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'number-of-employees-tree',
            component: filterableTreeFactory({
                basePath: ['order', 'addParams', 'numberOfEmployees', 'tree']
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id: 'numberOfEmployees',
                onItemCheck: numberOfEmployees.onItemCheck,
                onSetAll: numberOfEmployees.onSetAll,
                minFilterLength: 2,
                showOnlyTree: true,
                isInnerTree: true
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'text',
            component: Text,
            props: {
                signals: {
                    inputText: signalsAddParams.inputText,
                    blurText: signalsAddParams.blurText
                },
                position: 'leftToRight',
                scheme: SCHEMES.number
            },
            watcher: (attributes) => ({
                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'value',
                    attributes['cat-index']],
                error: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'error', attributes['cat-index']]
            })
        },
        {
            name: 'number-of-filials-select',
            component: Select,
            props: {
                signalOnSelect: filials.selectFilialsNumber,
                signalOnToggle: utils.togglePopupFromArgs
            },
            watcher: {
                options: ['order', 'addParams', 'numberOfFilials', 'options'],
                isDisable: ['order', 'addParams', 'numberOfFilials', 'isDisable'],
                isOpen: ['order', 'addParams', 'numberOfFilials', 'isOpen'],
                isError: ['order', 'addParams', 'numberOfFilials', 'isError'],
                header: ['order', 'addParams', 'numberOfFilials', 'header']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/content/filter/index.js